import React, { useState, useEffect } from 'react';
import { useTheme } from "../../context/ThemeContext";
import { motion } from 'framer-motion';
import ProfilePicture from '../../components/ProfilePicture';
import ThemeToggle from '../../components/ThemeSwitcher/ThemeSwitcher';
import { MdError, MdPlayArrow } from 'react-icons/md';
import { FaCheckCircle } from 'react-icons/fa';
import { getLearnerQuiz } from '../../api/api';
import LoaderModal from '../../components/LoaderModal';
import { useNavigate } from "react-router-dom";
import Card from '../../components/Card';

const LearnerHomePage = () => {
    const { themeStyles } = useTheme();
    const [quizList, setQuizList] = useState([]);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    const getQuiz = async () => {
        try {
            setLoader(true)
            const quizList = await getLearnerQuiz(localStorage.getItem("learnerId"));
            setQuizList(quizList.quizzes)
            if (quizList.quizzes.length == 0) {
                alert("No Quizzes Assigned too the learner");
            }
        } catch (error) {
            alert("Something went wrong please try again");
        } finally {
            setLoader(false);
        }

    }

    useEffect(() => {
        getQuiz();
    }, []);

    const navigateToQuiz = (quizId) => {
        navigate(`/quiz/${quizId}`);
    }

    return (
        <div
            className="min-h-screen"
            style={{ backgroundColor: themeStyles.background, color: themeStyles.text }}
        >

            {loader && <LoaderModal notLeftMargin={true} />}
            <div className="w-full bg-custom-blue text-white p-4 flex items-center relative fixed top-0 left-0 z-10">
                {/* Left: Profile Picture */}
                <div className="flex-shrink-0">
                    <ProfilePicture quiz={true} learnerName={localStorage.getItem("learnerName")} />
                </div>

                {/* Right: Button and ThemeToggle */}
                <div className="ml-auto flex items-center space-x-4">
                    <ThemeToggle page="studentPage" />
                </div>

            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-10">
                {quizList.map((quiz, index) => (
                    <motion.div
                        key={quiz.quizId}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.15 }}
                    >
                        <div
                            style={{
                                backgroundColor: themeStyles.cardBackground,
                                height: '100%' // Ensures consistent height
                            }}
                            className="rounded-lg shadow-lg transform transition hover:scale-105 flex flex-col"
                        >
                            <div
                                style={{ backgroundColor: themeStyles.cardContentBackground }}
                                className="p-6 rounded-t-lg flex-grow"
                            >
                                <h2 className="text-2xl font-bold mb-3">{quiz.name}</h2>
                                <p className="text-sm mb-4 italic">{quiz.description}</p>
                                <p className="text-base mb-2 font-medium">Total Marks: {quiz.totalMarks}</p>
                                <p className="text-base mb-2 font-medium">End Date: {new Date(quiz.endDate).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}
                                </p>
                            </div>
                            <div className="p-4 flex justify-between items-center border-t">
                                {quiz.status === 'Completed' && (
                                    <div className="flex py-1 items-center gap-2 text-green-500 font-bold">
                                        <FaCheckCircle />
                                        <span>Completed</span>
                                    </div>
                                )}
                                {quiz.status === 'Expired' && (
                                    <div className="flex py-1 items-center gap-2 text-red-500 font-bold">
                                        <MdError />
                                        <span>Expired</span>
                                    </div>
                                )}
                                {quiz.status === 'Pending' && (
                                    <button
                                        className="px-6 py-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg flex items-center gap-2 transition-all"
                                        style={{ backgroundColor: themeStyles.primaryColor }}
                                        onClick={() => navigateToQuiz(quiz.quizId)}
                                    >
                                        <MdPlayArrow />
                                        Start Quiz
                                    </button>
                                )}
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
            {!loader && quizList.length === 0 && (
                <div className="flex justify-center items-center h-full">
                    <Card className="w-full max-w-md text-center p-6 flex flex-col items-center justify-center" style={{ backgroundColor: themeStyles.cardBackground }}>
                        <h2 className="text-xl font-semibold mb-2">No Quizzes Available</h2>
                        <p>The learner hasn't been assigned any quizzes yet.</p>
                    </Card>
                </div>
            )}

        </div>
    );
};

export default LearnerHomePage;
